import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'
import isEmpty from 'lodash/isEmpty'
import { useInView } from 'react-intersection-observer'

function ServicesSection({
  children,
  isFullHeight,
  hasNoPadding,
  hasExtraPadding,
  className,
  customThreshold,
  theme,
  hasExtraPaddingTop,
  isFullWidth,
  hasNoYPadding,
}) {
  const [ref, inView] = useInView({
    threshold: customThreshold || 0.25,
  })

  return (
    <section
      ref={ref}
      className={cx('services__section', '--centered', `--${theme}`, {
        '--full-height': isFullHeight,
        '--full-width': isFullWidth,
        '--no-padding': hasNoPadding,
        '--no-y-padding': hasNoYPadding,
        '--has-extra-padding': hasExtraPadding,
        '--has-extra-padding-top': hasExtraPaddingTop,
        [className]: !isEmpty(className),
      })}
    >
      <div
        className={cx('services__section-container', {
          '--in-view': inView,
        })}
      >
        {children}
      </div>
    </section>
  )
}

ServicesSection.defaultProps = {
  theme: 'white',
}

ServicesSection.propTypes = {
  children: PropTypes.node.isRequired,
  isFullHeight: PropTypes.bool,
  hasNoPadding: PropTypes.bool,
  hasExtraPadding: PropTypes.bool,
  customThreshold: PropTypes.number,
  hasNoYPadding: PropTypes.bool,
  className: PropTypes.string,
  theme: PropTypes.string,
  hasExtraPaddingTop: PropTypes.bool,
  isFullWidth: PropTypes.bool,
}

export default ServicesSection
